// extracted by mini-css-extract-plugin
export var closeButton = "_3p-3";
export var header = "_3p-0";
export var link = "_3p-1";
export var retryButton = "_3p-2";